
(function () {

	var cm = include('cm');

	function Main()
	{
		//Start
		// cm.debug = true;
		this.debugLayer = null;
		this.initializeStages();
		this.initLayers();
		this.boot();
		this.tick = 0;
		this.currentManifest = null;
		this.selectedPlanet = null;
		this.videoPlayer = null;
		this.selectedPlanetNum = null;
		this.level = 1;
		this.lastPos= {x:0, y:0};
		this.previousPos = {x:0, y:0};
		this.multiplier = 1;
		this.gameSettings = null;
		this.cursorPosition = 0;
		this.pause = false;
		this.isLoading = false;
		this.introVideoPlayed = false;
		this.garbageToCollect = ["apple", "bagel", "banana", "cap", "cheese", "chips", "clock", "coffee-can", "coffee-flitter", "cord", "crayon-red", "crayon-yellow", "cup", "doll", "egg", "glass-bottle", "jar", "long-box", "magazine", "milk", "orange-bottle", "orange", "phone", "pizza", "plastic-bag", "shampoo-bottle", "shoes", "six-pack-rings", "soda", "stake", "stoll", "straw", "styrofoam-container", "tea-bag", "water-bottle", "dead-flower-1", "stack-food", "stack-ball", "tire", "stack-brick", "newspaper", "hat-1", "balloon"];
		this.garbageCollected = [];
		//settings ship
		this.speed = 1;
		this.speedPos = 1;
		this.difficulty = 1;
		this.musicVolume = 1;
		this.sfxVolume = 1;
		this.voVolume = 1;
		this.ccSettings = false;
		this.score = 0;
		cm.main = this;

		this.ready = true;

	}
	var p = Main.prototype;

	p.boot = function()
	{
		//Set Config
		cm.Assets.setAssetsDictionary(cm.app.config.assets);

		cm.ViewControl.registerView("TitleView", cm.View.TitleView, false);
		cm.ViewControl.registerView("CollectionView", cm.View.CollectionView, false);
		cm.ViewControl.registerView("SpaceView", cm.View.SpaceView, false);
		cm.ViewControl.registerView("SortView", cm.View.SortView, false);
		cm.ViewControl.registerView("StackView", cm.View.StackView, false);


		cm.Assets.load(["Boot"], this.onBootLoad.bind(this));

		//Remove edit for delivery

		if(window.edit){
			window.edit.init(cm.app.display.stage);
		}
	};


	p.preloadVideo = function()
	{
		var shipSettings = localStorage.getItem('shipSettings');
		var settings = JSON.parse(shipSettings);
		if (cm.ViewControl.currentID === "TitleView") {
			if (settings && !settings.ccSettings || !app.captions.mute) {
				cm.main.videoPlayer = new cm.VideoPlayer('assets/video/cyberchase-intro-captions.mp4', 'container', { id: 'video', autoPlay: false });
			} else {
				cm.main.videoPlayer = new cm.VideoPlayer('assets/video/cyberchase-intro-low.mp4', 'container', { id: 'video', autoPlay: false });
			}
			cm.main.videoPlayer.video.preload = 'auto';
		} else {
			if (settings && !settings.ccSettings || !app.captions.mute) {
				cm.main.videoPlayer = new cm.VideoPlayer('assets/video/cyberchase-end-captions.mp4', 'container', { id: 'video', autoPlay: false });
			} else{
				cm.main.videoPlayer = new cm.VideoPlayer('assets/video/cyberchase-end.mp4', 'container', { id: 'video', autoPlay: false });
			}
			cm.main.videoPlayer.video.preload = 'auto';
		}
	};

	p.onBootLoad = function()
	{
		cm.ViewControl.TransitionClass = cm.LoaderTransition;
		cm.ViewControl.setTransitionLayer(cm.Layer.s.Transition, cm.ViewControl.TransitionClass);

		cm.Assets.load(["Title"], this.gotoStartView.bind(this), null, cm.ViewControl.transitionOverlay.progressBar.bind(cm.ViewControl.transitionOverlay));
	};

	p.callTitleLoader = function()
	{
		var t = cm.ViewControl.transitionOverlay.callLoader();
		cjs.Tween.get(this).wait(t).call(this.loadGame, ["Space", this.gotoGameView.bind(this)], this);
	};

	p.loadSceneTransition = function(view, callback, unloadMani)
	{
		var t = cm.ViewControl.transitionOverlay.callLoader();
		cjs.Tween.get(this).wait(t).call(this.loadGame, [view, callback, unloadMani], this);

	};

	p.loadGame = function(view, callback, unloadMani)
	{
		view = typeof view === 'string' ? [view] : view;
		cm.Assets.load(view, callback, null, cm.ViewControl.transitionOverlay.progressBar.bind(cm.ViewControl.transitionOverlay));
	};

	p.gotoGameView = function()
	{
		cm.ViewControl.gotoView("SpaceView");
	};

	p.gotoStartView = function()
	{

		cm.ViewControl.gotoView("TitleView");
	};

	p.resize = function(w, h)
	{
		cm.Layer.alignLayers(w, h);
		cm.ViewControl.resize(w, h);
	};

	p.initializeStages = function()
	{
		var gameStage = this.gameStage = cm.app.display.stage;
		gameStage.snapToPixelEnabled = true;
		gameStage.preventSelection = false; //Do this to allow an iframe to get focus
		//Setup mouse or touch
		if(cm.Device.mobile && cjs.Touch.isSupported()) {
			//Enable Touchevents
			cjs.Touch.disable(this.gameStage);
			cjs.Touch.enable(this.gameStage, true);
			//Remove Mouseevents
			gameStage.enableDOMEvents(false);
		}else {
			//!!! This is a performance hit, especially on mobile
			//But we're only adding mouseover to Desktop
			gameStage.enableMouseOver(30);
			cm.Keyboard.bind(cm.Keyboard.KEYS.UP_ARROW, "upKey");
			cm.Keyboard.bind(cm.Keyboard.KEYS.DOWN_ARROW, "downKey");
			cm.Keyboard.bind(cm.Keyboard.KEYS.LEFT_ARROW, "leftKey");
			cm.Keyboard.bind(cm.Keyboard.KEYS.RIGHT_ARROW, "rightKey");
			cm.Keyboard.bind(cm.Keyboard.KEYS.SPACE, "space");
			cm.Keyboard.bind(cm.Keyboard.KEYS.TAB, "tabKey");
			cm.Keyboard.bind(cm.Keyboard.KEYS.ENTER, "enterKey");
		}

	};

	p.initLayers = function() {
		this.gameStage.addChild(
			new cm.Layer("Views", 0.5, 0.5),
			new cm.Layer("Transition", 0.5, 0.5)
		);

		cm.Layer.alignLayers();
		cm.ViewControl.setViewLayer(cm.Layer.s.Views);

		if(cm.debug) {
			this.debugLayer = new cm.Layer("PhysicsDebug", 0.5, 0.5);
			this.gameStage.addChild(this.debugLayer);
		}
	};

	p.update = function( tick )
	{
		if (!this.ready)
		{
			return;
		}

		if(tick > 50)
			tick = 50;
		this.tick = tick * 0.001;
		cm.ViewControl.update(tick);
	};
	cm.Main = Main;
})();

